import { render, staticRenderFns } from "./EditGeneralSettings.vue?vue&type=template&id=70607f7e&"
import script from "./EditGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./EditGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditGeneralSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports